import qs from 'qs'
import { Analytics } from '@ycos/analytics'

export const siteMerchCtaTrack = ({ item, layoutVariantAllowlist, layoutVariantBlocklist }) => {
  const { href, layoutVariant } = item

  // Allowlist/blocklist handling
  if (
    (layoutVariantAllowlist && !layoutVariantAllowlist.includes(layoutVariant)) ||
    (layoutVariantBlocklist && layoutVariantBlocklist.includes(layoutVariant))
  ) {
    return {}
  }
  // Proceed with the rest of the logic if:
  // - `layoutVariantAllowlist`, `layoutVariantBlocklist` NOT provided, OR
  // - `item.layoutVariant` matches `layoutVariantAllowlist`
  // - `item.layoutVariant` not matches `layoutVariantBlocklist`

  // Exit early if no href or no analytics string in href
  if (!href || !href.includes('cm_sp=')) return {}

  const siteMerchData = getSiteMerchObject(item)
  if (!siteMerchData) return {}

  const analytics = new Analytics({})

  return {
    item,
    onTargetClick: ({ isEndCarouselClick = false, specificItem = null } = {}) => {
      analytics.trackEvent({
        event: 'site merchandising - click',
        effect: isEndCarouselClick ? 'end carousel campaign click' : 'campaign click',
        category: {
          primaryCategory: 'site merchandising',
          subCategory: 'campaign'
        },
        attributes: {
          siteMerchandising: specificItem ? getSiteMerchObject(specificItem) : siteMerchData
        }
      })
    }
  }
}

export const getSiteMerchObject = (component) => {
  const { href, rootPosition } = component

  if (!href || !href.includes('cm_sp=')) return

  const campaignData = getCampaignEntry(href)
  if (!campaignData) return

  return {
    ...campaignData,
    modulePosition: rootPosition
  }
}

export const getCampaignEntry = (href) => {
  const queryString = href.split('?')[1]
  if (!queryString) return

  const queryParams = qs.parse(queryString)
  const cmSp = queryParams.cm_sp

  if (!cmSp) return

  const [placement, position, campaignName, campaignStartDate] = cmSp.split('-_-') || []

  if (![placement, position, campaignName, campaignStartDate].every(Boolean)) {
    return
  }

  return {
    placement,
    position,
    campaignName,
    campaignStartDate
  }
}
